module.exports = function(input) {
  const { name, email, password, passwordConfirm } = input;
  if (!name) return "Please enter a first name";
  if (name.length <= 1) return "Names must be at least two characters long";
  if (!email) return "Please enter a valid email";
  // eslint-disable-next-line
  const emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const goodEmail = emailRegEx.test(email);
  if (!goodEmail) return "Please enter a valid email";
  if (!password) return "Please enter a password of 6 or more characters";
  if (password !== passwordConfirm) return "Your passwords didn't match!";
  if (password.length < 6)
    return "Please enter a password of 6 or more characters";
  //otherwise, return null
  return null;
};



// WEBPACK FOOTER //
// ./src/services/inputValidation.js